import React from "react";
import Box from "components/common/Box";
import { CircularProgress } from "@mui/material";
import Grid from "components/common/Grid";
import DashboardOverview from "components/Dashboard/DashboardOverview";
import DashboardRevenue from "components/Dashboard/DashboardRevenue";
import DashboardCustomer from "components/Dashboard/DashboardCustomer";
import DashboardTimeConsumed from "components/Dashboard/DashboardTimeConsumed";
import DashboardPowerConsumed from "components/Dashboard/DashboardPowerConsumed";
import DashboardPopularTimes from "components/Dashboard/DashboardPopularTimes";
import { format, lastDayOfMonth, lastDayOfWeek , lastDayOfYear , subDays } from "date-fns";

class DashboardContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        vendor_id: "",
        manufacturer_id: "",
        model_id: "",
        station_id: "",
        from_date: "",
        to_date: "",
        fromat_date_from: "",
        fromat_date_to: "",
      },
      formError: {
        vendor_id: false,
        station_id: false,
        model_id: false,
        manufacturer_id: false,
        filter_date: false,
        status: false,
      },

      ErrorMsg: "",
    };
  }

  handleDatePickerOpen = () => {
    this.setState({ datePickerOpen: true });
  };

  handleDatePickerClose = () => {
    this.setState({ datePickerOpen: false });
  };

  async componentDidMount() {


    this.handleFilterApiData();

    await this.props.getManufacturerAction();
    await this.props.getVendorNameDataAction();

    const model_id1 = this.state.formData.manufacturer_id;
    await this.props.getVehiclesMasterAction(model_id1);

    const vendor_id1 = this.state.formData.vendor_id;
    await this.props.getLocationAction(vendor_id1);
  }

  handleFilterApiData = async () => {
    const {
      model_id,
      station_id,
      manufacturer_id,
      from_date,
      to_date,
      vendor_id,
    } = this.state.formData;
    const payload = {
      vendor_id: vendor_id=='all'?'':vendor_id,
      model_id: model_id=='all'?'':model_id,
      station_id: station_id=='all'?'': station_id,
      manufacturer_id: manufacturer_id=='all'?'':manufacturer_id,
      from_date: from_date,
      to_date: to_date,
    };
    if (
      vendor_id != undefined &&
      model_id != undefined &&
      station_id != undefined &&
      manufacturer_id != undefined &&
      from_date != undefined &&
      to_date != undefined
    ) {
      this.props.getDashboardAction(payload);
      this.props.getcustomerAction(payload);
      this.props.gettimeAction(payload);
      this.props.getpowerAction(payload);
      this.props.getpopularAction(payload);
    }
  };
  handleReset = async () =>{
    const {
      model_id,
      station_id,
      manufacturer_id,
      from_date,
      to_date,
      vendor_id,
    } = this.state.formData;
    const payload = {
      vendor_id: vendor_id=='all'?'':vendor_id,
      model_id: model_id=='all'?'':model_id,
      station_id: station_id=='all'?'': station_id,
      manufacturer_id: manufacturer_id=='all'?'':manufacturer_id,
     
    };
    if (
      vendor_id != undefined &&
      model_id != undefined &&
      station_id != undefined &&
      manufacturer_id != undefined &&
      from_date != undefined &&
      to_date != undefined
    ) {
      this.props.getDashboardAction(payload);
      this.props.getcustomerAction(payload);
      this.props.gettimeAction(payload);
      this.props.getpowerAction(payload);
      this.props.getpopularAction(payload);
    }
    this.setState({ formData: {
      from_date: "",
      to_date: "",
    }})
  }

  handleChange = (name, value) => {
    let { formData } = this.state;
    let from_date = "";
    let to_date = format(new Date(), "yyyy-MM-dd");

    if (name==="Current Month"){
      this.setState({ formData });

    }

    if (name === "day") {
      from_date = format(new Date(), "yyyy-MM-dd");
    }
    if (name === "week") {
       const today = new Date()
        today.setDate(today.getDate() - today.getDay())
       const lastDayOfWeekVar = format(lastDayOfWeek(new Date()), 'yyyy-MM-dd')
       from_date = subDays(new Date(lastDayOfWeekVar), 12);
        to_date= subDays(new Date(lastDayOfWeekVar), 6);

    }
    if (name === "month") {

      const today = new Date()
      today.setDate(1);
      today.setMonth(today.getMonth() - 1);

      const firstDateOfMonth = format(today, 'yyyy-MM-01')
      const lastDateOfMonth = format(lastDayOfMonth(today), 'yyyy-MM-dd')
      from_date = firstDateOfMonth;
      to_date = lastDateOfMonth;
    }
    if (name === "year") {
      const today = new Date()
      today.setDate(1)
      today.setFullYear(today.getFullYear()-1)
      const firstDateOfYear =format(today,'yyyy-01-01')
      const lastDayOfYearzz = format(lastDayOfYear(today),'yyyy-MM-dd')
      from_date = firstDateOfYear;
      to_date = lastDayOfYearzz;
    
    }
    if (name === "custom") {
      from_date = this.state.formData.from_date;
      to_date = this.state.formData.to_date;
    }
    if (name === "from_date") {
      from_date = format(new Date(value), "yyyy-MM-dd");
      to_date = this.state.formData.to_date;
    }
    if (name === "to_date") {
      from_date = this.state.formData.from_date;
      to_date = format(new Date(value), "yyyy-MM-dd");
    } else {
      formData[name] = value;
      this.setState({ formData });
    }

    if (name !== "from_date" && name !== "to_date") {
      setTimeout(() => {
        this.handleFilterApiData();
      }, 1000);
    }
 

    this.setState({
      formData: {
        ...this.state.formData,
        from_date: from_date,
        to_date: to_date,
      },
    });

    const model_id1 = this.state.formData.manufacturer_id;
    this.props.getVehiclesMasterAction(model_id1);

    const vendor_id1 = this.state.formData.vendor_id;
    this.props.getLocationAction(vendor_id1);
  };
  onDatePickerSub = async () => {
    this.handleFilterApiData();
  };

  timeConvert(n) {
    const num = n;
    const hours = (num / 60);
    const rhours = Math.floor(hours);
    const minutes = (hours - rhours) * 60;
    const rminutes = Math.round(minutes);
    return rhours + " hour  " + rminutes + " min";
  }

  render() {
    var arr = [];
    var timeArr=[];
    if (this.props.populartimesdataList?.result?.best_time) {
      arr.push(this.props.populartimesdataList?.result?.best_time)
      arr.push(this.props.populartimesdataList?.result?.worst_time)
      arr.map((item,i)=>{
        if (i<2){
          timeArr.push(item.time);
        }
        

      })
     
    }
  
    var timeValueArr=[];
    if (this.props.populartimesdataList?.result?.best_time) {
      arr.push(this.props.populartimesdataList?.result?.best_time)
      arr.push(this.props.populartimesdataList?.result?.worst_time)
      arr.map((item,i)=>{
        if (i<2){
          timeValueArr.push(item.timeValue);
        }
        

      })
    }

    const time = this.props?.timeconsumeddataList;

    const timeconsume = [];
    if (time?.result?.time_consumed_by_brands?.length > 0) {
      time?.result?.time_consumed_by_brands?.map((item) => {
        timeconsume.push({
          name: `${item.name.slice(
            0,
            20
          )}... <span style='margin-right:240px; flexWrap:wrap'>${this.timeConvert(item.value)
            }</span>`,
          y: item.value,
        });
      });
    }

    const power = this.props.powerconsumeddataList;

    const isLoadingdashboardrevenue = this.props.isLoadingdashboardrevenue;
    var consume = [];

    if (power?.result?.power_consumed_by_brands.length > 0) {
      power?.result?.power_consumed_by_brands?.map((item) => {
        consume.push({
          name: `${item.name.slice(
            0,
            20
          )}... <span style='margin-right:240px; flexWrap:wrap'>${item.value
            }kw</span>`,
          y: item.value,
        });
      });
    }

    let options = {
      chart: {
        type: "spline",
        lineColor: "#000000",
      },
      credits: false,
      title: {
        text: "",
        tickInterval: 1,
      },
      yAxis: {
        lineColor: "#19AA69",
        title: {
          text: "",
        },
      },
      plotOptions: {
        spline: {
          marker: {
            radius: 0,
          },
        },
      },
      xAxis: {
        categories: this.props?.dashboardrevenueList?.result?.dates || [],
        lineColor: "#19AA69",
      },

      legend: {
        align: "right",
        verticalAlign: "top",
        x: 0,
        y: 0,
      },

      series: [
        {
          name: "Charging",
          data: this.props?.dashboardrevenueList?.result?.revenue || [],
          lineColor: "#19AA69",
        },
      ],
    };

    const Img404 =
      "https://miro.medium.com/max/720/1*DeBkx8vjbumpCO-ZkPE9Cw.png";

    const total = this.props?.cutomersdataList;
    const isLoadingcustomerdata = this.props.isLoadingcustomerdata;

    const returning_customers =
      this.props.cutomersdataList?.result?.returning_customers;
    const total_customers =
      this.props.cutomersdataList?.result?.total_customers;
    const rc_data = (returning_customers * 100) / total_customers;

    const unique_customers =
      this.props.cutomersdataList?.result?.uniqe_customers;
    const uc_data = (unique_customers * 100) / total_customers;

    const options_pie1 = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: "pie",
        width: 408,
        height: 202,
        style: {
          float: "left",
        },
      },
      title: {
        text: "",
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
      },
      legend: {
        align: "right",
        verticalAlign: "middle",
        x: 0,
        y: -20,
        itemMarginTop: 20,
        useHTML: true,
      },
      accessibility: {
        point: {
          valueSuffix: "%",
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      credits: false,
      series: [
        {
          innerSize: "90%",
          name: "Brands",
          colorByPoint: true,
          data: [
            {
              name: `Returning Customers <span style='margin-left:70px;'>${this.props?.cutomersdataList?.result?.returning_customers
                ? this.props?.cutomersdataList?.result?.returning_customers
                : "0"
                }</span>`,
              y: rc_data,
              selected: true,
              color: "#28D0DC",
            },
            {
              name: `Unique Customers <span style='margin-left:85px;'>${this.props?.cutomersdataList?.result?.uniqe_customers
                ? this.props?.cutomersdataList?.result?.uniqe_customers
                : "0"
                }</span>`,
              y: uc_data,
              color: "#4C72B7",
            },
          ],
        },
      ],
    };



    const isLoadingtimeconsumeddata = this.props.isLoadingtimeconsumeddata;

    const options_pie2 = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: "pie",
        width: 690,
        height: 200,
        style: {
          float: "left",
        },
      },
      credits: false,
      title: {
        text: "",
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
      },
      accessibility: {
        point: {
          valueSuffix: "%",
        },
      },
      legend: {
        align: "right",
        verticalAlign: "middle",
        x: 0,
        y: -20,
        itemMarginTop: 20,
        useHTML: true,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      series: [
        {
          innerSize: "90%",
          name: "Brands",
          colorByPoint: true,
          data: timeconsume,
        },
      ],
    };

    const isLoadingpowerconsumeddata = this.props.isLoadingpowerconsumeddata;

    const options_pie3 = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: "pie",
        width: 670,
        height: 200,
        style: {
          float: "left",
        },
      },
      title: {
        text: "",
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
      },
      accessibility: {
        point: {
          valueSuffix: "%",
        },
      },
      legend: {
        align: "right",
        verticalAlign: "middle",
        x: 0,
        y: -20,
        itemMarginTop: 20,
        useHTML: true,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      credits: false,
      series: [
        {
          innerSize: "90%",
          name: "Brands",
          colorByPoint: true,
          data: consume,
        },
      ],
    };

    const isLoadingpopulartimesdata = this.props.isLoadingpopulartimesdata;

    const popular = this.props.populartimesdataList;


    const options_bar = {
      chart: {
        type: "column",
        height: 200,
        width: 450,
        style: {
          float: "center",
        },
      },
      title: {
        text: "",
        tickInterval: 1,
      },
      xAxis: {
        categories: timeArr,
        crosshair: true,
      },
      yAxis: {
        visible: true,
        min: 0,
        lineColor: "#cacaca",
        title: {
          text: "",
        },
        lineWidth: 1,
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
        footerFormat: "</table>",
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: "Popular Times",
          data: timeValueArr,
          color: "#4C72B7",
        },
      ],
    };


    return (
      <>
        {this.props.isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "300px",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box sx={{ marginTop: "1rem" }}>
            <Grid container spacing={2}>
              <DashboardOverview
                onDatePickerSub={this.onDatePickerSub}
                state={this.state}
                data={this.props}
                onchange={this.handleChange}
                onclick={this.handleDatePickerOpen}
                open={this.state.datePickerOpen}
                onClose={this.handleDatePickerClose}
                handleChange={this.handleChange}
                props={this.props}
                formData={this.state.formData}
                formError={this.state.formError}
                isError={this.state.ErrorMsg}
                vendorname={this.props.VendorNameData}
                handleReset={this.handleReset}
              />
            </Grid>
            {this.props.isLoading ? (
              <CircularProgress />
            ) : (
              <Grid container spacing={2}>
                <Grid item xs={12} sx={{ marginTop: "15px" }}>
                  <DashboardRevenue
                    options={options}
                    isLoadingdashboardrevenue={isLoadingdashboardrevenue}
                    data={this.props?.dashboardrevenueList?.result}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <DashboardCustomer
                    options={options_pie1}
                    Img404={Img404}
                    total={total}
                    isLoadingcustomerdata={isLoadingcustomerdata}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <DashboardTimeConsumed
                    options={options_pie2}
                    time={time}
                    isLoadingtimeconsumeddata={isLoadingtimeconsumeddata}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <DashboardPowerConsumed
                    options={options_pie3}
                    power={power}
                    isLoadingpowerconsumeddata={isLoadingpowerconsumeddata}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <DashboardPopularTimes
                    options={options_bar}
                    popular={popular}
                    isLoadingpopulartimesdata={isLoadingpopulartimesdata}
                  />
                </Grid>

                
              </Grid>
            )}
          </Box>
        )}
      </>
    );
  }
}

export default DashboardContainer;
